export { default as ShipmentCostTemplate } from './ShipmentCostTemplate';
export { default as ShipmentCostListTemplate } from './ShipmentCostListTemplate';
export { default as ShipmentCostChargeListTemplate } from './ShipmentCostChargeListTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/shipment-cost/pages/index.js